import { reducersActions } from "./new-actions";

import axiosInstance from "../../utils/axiosInterceptor";
import { apicall } from "../../services/api";

const {
    FETCH_TAGS_REQUEST,
    FETCH_TAGS_SUCCESS,
    FETCH_TAGS_FAILURE,
} = reducersActions;


export const fetchTags = () => async (dispatch) => {
    dispatch({ type: FETCH_TAGS_REQUEST });
    try {
        const response = await apicall(`offerings/tags`, "get", null, {}, "v3");

        dispatch({
            type: FETCH_TAGS_SUCCESS,
            payload: response.data,
        });
        
        return response.data; // Return the data for further use if needed
    } catch (error) {
        dispatch({
            type: FETCH_TAGS_FAILURE,
            payload: error.message,
        });
    }
};
